import { useBasket } from '../(basket)'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { Link, usePathname } from '@/i18n/navigation'

export const OrderNavigation = () => {
  const t = useTranslations()
  const pathname = usePathname()
  const { isCompany } = useBasket()

  const items = isCompany
    ? [
        { title: t('Products'), path: '/bedrifter' },
        { title: t('Checkout'), path: '/bedrift-info' },
      ]
    : [
        { title: t('Products'), path: '/bestill-privat' },
        { title: t('Pickup'), path: '/hentested' },
        { title: t('Checkout'), path: '/kunde-info' },
      ]

  return (
    <nav>
      <ol className="flex flex-col gap-4 sm:flex-row">
        {items.map(({ title, path }, index) => (
          <li
            key={path}
            className={cn('flex-1 border-t-4 border-t-black', {
              'opacity-30 hover:opacity-100': pathname !== path,
            })}
          >
            <Link className="flex items-center justify-start gap-2 py-4 font-semibold md:text-lg" href={path}>
              <span className="flex size-6 items-center justify-center rounded-full bg-black leading-[1] text-white">
                {index + 1}
              </span>
              <span>{title}</span>
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  )
}
